import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import Select from 'react-select'

const PkSelect = ({ options }) => {
    const parsedOptions = options
        .map(o => ({
            selected: o.selected,
            label: o.text,
            value: o.value
        }));

    const defaultvalue = parsedOptions.find(o => o.selected) ?? parsedOptions[0];

    const colorStyles = {
        option: (styles, { isFocused, isSelected }) => {
            return { ...styles, backgroundColor: isFocused ? '#EFF2C8' : isSelected ? '#EFF2C8' : undefined, color: isSelected ? '#000000' : undefined };
        },
    };

    return (
        <div>
            <Select options={parsedOptions}
                defaultValue={defaultvalue}
                onChange={(newvalue) => {
                    window.location = newvalue.value;
                }}
                isSearchable={false}
                theme={(theme) => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary: 'black',
                    },
                })}
                styles={colorStyles}
            />
        </div>
    );
};

export default PkSelect;